import { useContext, useEffect, useState } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { postSelectedReport } from '../apiCalls';
import { StoreContext } from '../Store';
import DataTable from './DataTable1';

const ReportsResults = () => {
  const store = useContext(StoreContext);
  const { endPoint, reportName, paramCombination, startDate, endDate, startDate2, endDate2, customer } = useParams();
  const [searchParams] = useSearchParams();
  const viewDeleted = searchParams.get('viewDeleted') === 'true';

  const [invoices, setInvoices] = useState([{ '': '' }]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const inputStyle = { width: '100%', boxSizing: 'border-box', border: 'none', backgroundColor: 'transparent' };
  // Default Header Styles
  const headerStyle = { fontSize: '12px' };
  // Default Row Styles
  const defaultStyle = { fontSize: '14px' };
  const errorStyle = { fontSize: '16px', textAlign: 'center', fontWeight: '600' };
  // Override individual row styles

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const fd = new FormData();

        fd.append('paramCombination', paramCombination);
        fd.append('startDate', startDate);
        fd.append('endDate', endDate);
        fd.append('startDate2', startDate2);
        fd.append('endDate2', endDate2);
        fd.append('customer', customer);
        fd.append('parent', customer);
        fd.append('includeDeleted', viewDeleted);
        const result = await postSelectedReport(endPoint, fd);
        setInvoices(result);
        return result;
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [endPoint]);

  const backToParameters = () => {
    if (store.reportParams[0][0] && store.reportParams[0][0]?.parameters !== '') {
      navigate(`/ReportsAdmin/${store.reportParams[0][0].data}`);
      return;
    } else {
      navigate(`/ReportsList`);
      return;
    }
  };

  return (
    <>
      <Container className="full-width-container">
        <section className="floating-box-report" style={{ minWidth: '100%' }}>
          <div className="d-flex flex-row justify-content-between">
            <h1 className="floating-box-header-general">{reportName}</h1>

            {paramCombination === '1' && (
              <div
                className="d-flex flex-column "
                style={{ marginRight: '15px', paddingTop: '1.3rem', fontWeight: '400', fontSize: '0.8rem' }}
              >
                <div className="d-flex flex-row justify-content-between ">
                  <span className="text-eoriblue d-flex bold" style={{ marginRight: '10px' }}>
                    Completed Start:{' '}
                  </span>
                  <span className="d-flex ">{startDate}</span>
                </div>
                <div className="d-flex flex-row justify-content-between">
                  <span className="text-eoriblue d-flex bold" style={{ marginRight: '10px' }}>
                    Completed End:
                  </span>
                  <span className="d-flex ">{endDate}</span>
                </div>
              </div>
            )}
            {paramCombination === '2' && (
              <div
                className="d-flex flex-column "
                style={{ marginRight: '15px', paddingTop: '1.3rem', fontWeight: '400', fontSize: '0.8rem' }}
              >
                <div className="d-flex flex-row justify-content-between ">
                  <span className="text-eoriblue d-flex bold" style={{ marginRight: '10px' }}>
                    Created Start:{' '}
                  </span>
                  <span className="d-flex ">{startDate}</span>
                </div>
                <div className="d-flex flex-row justify-content-between">
                  <span className="text-eoriblue d-flex bold" style={{ marginRight: '10px' }}>
                    Created End:
                  </span>
                  <span className="d-flex ">{endDate}</span>
                </div>
              </div>
            )}
            {paramCombination === '3' && (
              <div
                className="d-flex flex-column "
                style={{ marginRight: '15px', paddingTop: '1.3rem', fontWeight: '400', fontSize: '0.8rem' }}
              >
                <div className="d-flex flex-row justify-content-between ">
                  <span className="text-eoriblue d-flex bold" style={{ marginRight: '10px' }}>
                    Created Start:{' '}
                  </span>
                  <span className="d-flex ">{startDate}</span>
                </div>
                <div className="d-flex flex-row justify-content-between">
                  <span className="text-eoriblue d-flex bold" style={{ marginRight: '10px' }}>
                    Created End:
                  </span>
                  <span className="d-flex ">{endDate}</span>
                </div>
                <div className="d-flex flex-row justify-content-between ">
                  <span className="text-eoriblue d-flex bold" style={{ marginRight: '10px' }}>
                    Completed Start:{' '}
                  </span>
                  <span className="d-flex ">{startDate2}</span>
                </div>
                <div className="d-flex flex-row justify-content-between">
                  <span className="text-eoriblue d-flex bold" style={{ marginRight: '10px' }}>
                    Completed End:
                  </span>
                  <span className="d-flex ">{endDate2}</span>
                </div>
              </div>
            )}
          </div>

          <div className="px-3 pt-4 report-results">
            {loading && (
              <div className="text-center my-5">
                <Spinner animation="border" variant="primary">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
                <div style={{ marginTop: '0.5rem' }}>Loading report results…</div>
              </div>
            )}

            {!loading && invoices.length === 0 && (
              <DataTable
                initialData={[{ '': 'No data available for the selected date range' }]}
                disabled={true}
                defaultStyle={errorStyle}
                headerStyle={headerStyle}
                sortable={false}
                filterable={false}
                inputStyle={inputStyle}
                rootClose={true}
                tableClassName="report-table"
                downloadable={false}
                returnPrev={() => backToParameters()}
              />
            )}

            {!loading && invoices.length > 0 && (
              <DataTable
                initialData={invoices}
                disabled={true}
                defaultStyle={defaultStyle}
                headerStyle={headerStyle}
                sortable={true}
                filterable={true}
                inputStyle={inputStyle}
                rootClose={true}
                downloadable={true}
                tableClassName="report-table"
                downloadFilename={reportName || 'report'}
                returnPrev={() => backToParameters()}
              />
            )}
          </div>
        </section>
      </Container>
    </>
  );
};

export default ReportsResults;
